export default "__VITE_ASSET__CLLF5HyL__"